export default __webpack_public_path__ + "static/media/Icon-left-arrow.013730e8.svg";